"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.indicatorStates = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _uiIcons = require("@blueprism/ui-icons");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var indicatorStates = {
  IDLE: 'idle',
  PENDING: 'pending',
  COMPLETE: 'complete',
  WARNING: 'warning'
};
exports.indicatorStates = indicatorStates;
var spin = (0, _styledComponents.keyframes)(["from{transform:rotate(0deg);}to{transform:rotate(360deg);}"]);

var Container = _styledComponents["default"].div.withConfig({
  displayName: "StatusIndicator__Container",
  componentId: "igagc7-0"
})(function (_ref) {
  var width = _ref.width,
      status = _ref.status,
      _ref$theme = _ref.theme,
      globalSizes = _ref$theme.globalSizes,
      color = _ref$theme.color;
  return (0, _styledComponents.css)(["padding:0.25rem ", ";border-radius:", " ", " 0.5rem ", ";width:", ";background:", ";display:", ";justify-content:flex-start;align-items:baseline;"], globalSizes.small, globalSizes.smallest, globalSizes.smallest, globalSizes.smallest, width, status === indicatorStates.WARNING ? color.warning : 'none', status === indicatorStates.IDLE ? 'none' : 'flex');
});

var StatusText = _styledComponents["default"].span.withConfig({
  displayName: "StatusIndicator__StatusText",
  componentId: "igagc7-1"
})(function (_ref2) {
  var _ref2$warning = _ref2.warning,
      warning = _ref2$warning === void 0 ? false : _ref2$warning,
      _ref2$theme = _ref2.theme,
      font = _ref2$theme.font,
      color = _ref2$theme.color;
  return (0, _styledComponents.css)(["font-size:0.75rem;margin-left:0.5rem;color:", ";font-weight:", ";"], warning ? color.paper : color.text, warning ? font.weight.bold : font.weight.regular);
});

var Spinner = _styledComponents["default"].div.withConfig({
  displayName: "StatusIndicator__Spinner",
  componentId: "igagc7-2"
})(["animation:0.8s linear infinite ", ";display:flex;justify-content:center;align-items:baseline;"], spin);

var StateContent = function StateContent(_ref3) {
  var state = _ref3.state,
      labels = _ref3.labels;

  var _labels = _slicedToArray(labels, 3),
      _labels$ = _labels[0],
      pendingLabel = _labels$ === void 0 ? '' : _labels$,
      _labels$2 = _labels[1],
      completeLabel = _labels$2 === void 0 ? '' : _labels$2,
      _labels$3 = _labels[2],
      warninglabel = _labels$3 === void 0 ? '' : _labels$3;

  var _React$useContext = _react["default"].useContext(_styledComponents.ThemeContext),
      color = _React$useContext.color;

  switch (state) {
    case indicatorStates.PENDING:
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(Spinner, null, /*#__PURE__*/_react["default"].createElement(_uiIcons.Rotate, {
        size: 8,
        color: color.action
      })), /*#__PURE__*/_react["default"].createElement(StatusText, null, pendingLabel));

    case indicatorStates.COMPLETE:
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_uiIcons.Tick, {
        size: 8,
        color: color.action
      }), /*#__PURE__*/_react["default"].createElement(StatusText, null, completeLabel));

    case indicatorStates.WARNING:
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_uiIcons.Alert, {
        size: 8,
        color: color.paper
      }), /*#__PURE__*/_react["default"].createElement(StatusText, {
        warning: true
      }, warninglabel));

    default:
      return null;
  }
};
/**
 * ### Visual feedback component
 *
 * This component acts to provide feedback to the user in relation to an event that has just taken place (e.g. saving a form). It has four states based on the steps of the progress each with its own styling. It is hidden in its `idle` state and is only visible in its other availble states, `pending`, `complete` or `warning`.
 */


var StatusIndicator = function StatusIndicator(_ref4) {
  var _ref4$status = _ref4.status,
      status = _ref4$status === void 0 ? indicatorStates.IDLE : _ref4$status,
      _ref4$statusLabels = _ref4.statusLabels,
      statusLabels = _ref4$statusLabels === void 0 ? [] : _ref4$statusLabels,
      _ref4$width = _ref4.width,
      width = _ref4$width === void 0 ? 'auto' : _ref4$width,
      rest = _objectWithoutProperties(_ref4, ["status", "statusLabels", "width"]);

  return /*#__PURE__*/_react["default"].createElement(Container, _extends({
    status: status,
    width: width
  }, rest), /*#__PURE__*/_react["default"].createElement(StateContent, {
    state: status,
    labels: statusLabels
  }));
};

var _default = StatusIndicator;
exports["default"] = _default;